import { motion } from 'framer-motion';

export function GlowingCTA({ children, onClick, className = '', type = 'button', disabled = false, ...props }) {
  return (
    <motion.button
      whileHover={disabled ? {} : { scale: 1.05 }}
      whileTap={disabled ? {} : { scale: 0.95 }}
      onClick={onClick}
      type={type}
      disabled={disabled}
      className={`relative px-8 py-4 rounded-full font-semibold text-white overflow-hidden group ${disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'} ${className}`}
      {...props}
    >
      {/* Compositor-friendly layered gradients using opacity transitions */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-cyan-500 transition-opacity duration-500 group-hover:opacity-0" />
      <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      <span className="relative z-10 flex items-center justify-center font-heading tracking-wide">
        {children}
      </span>
      <div className="absolute inset-0 rounded-full blur-xl bg-cyan-500/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
    </motion.button>
  );
}
